import { render } from "./News-page.vue?vue&type=template&id=5972fa08&scoped=true"
import script from "./News-page.vue?vue&type=script&lang=js"
export * from "./News-page.vue?vue&type=script&lang=js"

import "./News-page.vue?vue&type=style&index=0&id=5972fa08&scoped=true&lang=css"

import exportComponent from "/Users/thomas/Desktop/CNT/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5972fa08"]])

export default __exports__